import request from './request'

export const getShopReferrerWalletList = (params) => {
  return request({
    url: '/admin/shop-referrer-wallets',
    method: 'get',
    params
  })
}

export const getShopReferrerWalletInfo = (shopReferrerId) => {
  return request({
    url: `/admin/shop-referrer-wallets/referrer/${shopReferrerId}`,
    method: 'get'
  })
}

export const getShopReferrerWalletDetail = (id) => {
  return request({
    url: `/admin/shop-referrer-wallets/${id}`,
    method: 'get'
  })
}

export const getShopReferrerWalletTransactions = (shopReferrerId, params) => {
  return request({
    url: `/admin/shop-referrer-wallets/${shopReferrerId}/transactions`,
    method: 'get',
    params
  })
}

export const updateShopReferrerWallet = (id, data) => {
  return request({
    url: `/admin/shop-referrer-wallets/${id}`,
    method: 'put',
    data
  })
}
